import { NativeBridge } from './nativeBridge';
import { NativeBridgeBase } from './nativeBridgeBase';
import { NativeBridgeWrapper } from './nativeBridgeWrapper';

export class NativeBridgeFactory {
	static getBridge = (): NativeBridgeBase => {
		return window.accountConfigNative
			? NativeBridge.Instance
			: NativeBridgeWrapper.Instance;
	};
}
